<template>
  <div class="size-finder__tab size-finder__tab--fit-guide">
    <div class="size-finder__video-wrapper">
      <video-player
        v-if="tabContent.fitGuideVideo"
        class="size-finder__primary-video"
        toolbar-controls
        overlay-needed
        :image="tabContent.fitGuideVideo.preview_image"
        :video="getVideoSource(tabContent.fitGuideVideo.sources)"
      />
    </div>

    <h4
      v-if="tabContent.paragraphTitle"
      class="size-finder__tab-heading text-body-m-bold"
      v-text="tabContent.paragraphTitle"
    />

    <div
      v-if="tabContent.paragraphContent"
      class="size-finder__tab-paragraph"
      v-html="tabContent.paragraphContent"
    />

    <div
      v-if="tabContent.fitImage"
      class="size-finder__fit-image-wrapper"
    >
      <responsive-image
        class="size-finder__fit-image"
        :image="tabContent.fitImage"
        :sizes="sizes"
      />
    </div>
  </div>
</template>

<script>
import { values as breakpoints } from '~/config/breakpoints'
import VideoPlayer from '~async/video-player/video-player'
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'FitGuideTab',

  components: {
    VideoPlayer,
    ResponsiveImage,
  },

  props: {
    tabContent: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {

    /**
     * Compute responsive image sizes.
     * @returns {String}
    */
    sizes() {
      return `(min-width: ${breakpoints.l}) 510px, 960px`
    },
  },

  methods: {

    /**
     * Get video MP4 source object.
     * @param {Array} sources - Video sources.
     * @returns {Object}
     */
    getVideoSource(sources) {
      return sources.find((source) => source.format === 'mp4')
    },
  },
}
</script>
